import React from 'react'
import TablesContainer from '../components/TablesContainer/TablesContainer'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from '../resources/routes-constants'
import Banner from '../components/Banner/Banner'
import Button from '../components/Button/Button'
import betaTag from '../resources/images/fmw-beta-tag.png'

const PublicHomePage: React.FC = () => {
    const navigate = useNavigate()

    const getPreviousDay = (date = new Date()) => {
        const previous = new Date(date.getTime())
        previous.setDate(date.getDate() - 1)
        return previous
    }

    return (
        <div className="main-container">
            <div className="header-container">
                <div className="header-container__left-section">
                    <div className="header-container__left-section__top-row">
                        <span className="main-title">FM-world charts</span>
                        <div className="beta-tag-image-container">
                            <img src={betaTag} alt="FM-world BETA" />
                        </div>
                    </div>
                    <span className="main-subtitle">Le radio più ascoltate sull&apos;app di FM-world</span>
                    <span className="main-subtitle">
                        Dati relativi al giorno {getPreviousDay().toLocaleDateString()}
                    </span>
                </div>
            </div>
            <div />
            <div className="horizontal-divider" />
            <div className="login-banner-wrapper">
                <span className="login-banner-wrapper__title">
                    Esegui il login per visualizzare informazioni più dettagliate.
                </span>
                <Button label="Accedi" type="submit" onPress={() => navigate(ROUTES.LOGIN_ROUTE)} />
            </div>
            <span className="time-span-section-title">Ultima ora</span>
            <TablesContainer chartTimeSpan="last_hour" hideTvChart />
            <div className="horizontal-divider" />
            <Banner />
            <span className="time-span-section-title">Ultimo giorno</span>
            <TablesContainer chartTimeSpan="last_day" />
            <div className="horizontal-divider" />
            <span className="time-span-section-title">Ultimo mese</span>
            <TablesContainer chartTimeSpan="last_month" hasMoreThanTenElements />
            <div className="login-banner-wrapper">
                <span className="login-banner-wrapper__title">
                    Esegui il login per visualizzare informazioni più dettagliate.
                </span>
                <Button label="Accedi" type="submit" onPress={() => navigate(ROUTES.LOGIN_ROUTE)} />
            </div>
        </div>
    )
}

export default PublicHomePage
